<template>
 
  <div style="background-color: #f0f0f4;">
    <div class="item_title">核心成员</div>
    <div class="members" style=""><div class="onter-div">
      <div class="inner-div" v-for="(item, index) in core_items" :key="index" @click="dialogTableVisible = true,active_item=item">
        <div class="item-avater">
          <img style="" :src="item.src" alt="">
        </div>
        <div class="item-left">
          <div class="item-items">
            <span class="text1"><img src="../../assets/item1.png">姓名：</span>
            <div class="text2">{{item.name}}</div>
          </div>
          <div class="item-items">
           <span class="text1"><img src="../../assets/item2.png">学位：</span>
           <div class="text2">{{item.deg}}</div>
          </div>
          <div class="item-items" >
            <div><span class="text1"><img src="../../assets/item3.png">职位：</span></div>
            <div class="text2" style="display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;"><div v-for="j in item.pos">{{j}}</div></div>
          </div>
          <div class="item-items">
            <div><div class="text1"><img src="../../assets/item4.png">简介：</div></div>
            <div class="text2" style=" width: 100px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;">{{item.int}}</div>
          </div>
        </div>
        
      </div>
    </div></div>

    <div class="item_title">参与成员</div>
    <div class="members" style=""><div class="other_other_div">
        <div class="other_inner_div" v-for="(item, index) in other_items" :key="index" >
          <div class="other-item-avater">
            <img style="" :src="item.src" alt="">
          </div>
          <div class="text2">{{item.name}}</div>
        </div>
    </div></div>

    <el-dialog title="团队成员" :visible.sync="dialogTableVisible">
      <div style="display: flex;">
        <div style="width:40%;height:100%">
          <img style="width:100%;" :src="active_item.src" alt="">
        </div>
        <div class="item-left">
          
          <div class="di-item-items">
           <span class="di-text1"><img src="../../assets/item1.png">姓名：</span>
           <div class="di-text2">{{active_item.name}}</div>
          </div>
          <div class="di-item-items">
           <span class="di-text1"><img src="../../assets/item2.png">学位：</span>
           <div class="di-text2">{{active_item.deg}}</div>
          </div>
          <div class="di-item-items" >
            <div><span class="di-text1"><img src="../../assets/item3.png">职位：</span></div>
            <div class="di-text2"><div v-for="j in active_item.pos">{{j}}</div></div>
          </div>
          <div class="di-item-items">
            <div><div class="di-text1"><img src="../../assets/item4.png">简介：</div></div>
            <div class="di-text2" style=" width: 100px;">{{active_item.int}}</div>
          </div>
        </div>
      </div>
      
    </el-dialog>

  </div>
  
</template>

<script>

export default {
  name: 'ItemView',
  components: {

  },
  data(){
    return{
      dialogTableVisible: false,
      
      core_items:[
        {name:'李迎春',deg:'博士',pos:['农产品碳足迹因子基准数据库 研究员','中国农业科学院农业环境与可持续发展研究所 副研究员'],int:'主要从事低碳农业发展与农产品碳标签研究。采用全生命周期评价方法，定量核算我国典型农食产品碳足迹，探索农食产品碳标签计量方法与认证标准，构建农食产品碳标识与认证技术规范；解析不同农食产品碳排放构成，研发减排固碳技术，提出双碳目标下农食产品低碳发展路径。为地方政府、农业企业的低碳农食产品开发提供定制化解决方案。',src:require('../../assets/item/liyingchun.png')},
        {name:'马欣',deg:'博士',pos:['中国农业科学院农业环境与可持续发展研究所 研究员','智慧气象与农业气候资源利用创新团队 首席科学家'],int:'主要从事农业碳达峰路径、区域农业减排战略研究，探索新能源技术在农业减排中应用，为区域农业减排提供技术解决方案。',src:require('../../assets/item/maxin.png')},
        {name:'韩雪',deg:'博士',pos:['中国农业科学院农业环境与可持续发展研究所 副研究员'],int:'主要从事农产品碳足迹核算与低碳农业发展评价，构建区域和园区低碳农业发展评价指标体系，探索低碳农业发展综合评价方法，为区域和园区的低碳农业发展提供综合解决方案。',src:require('../../assets/item/hanxue.png')},
        {name:'李阔',deg:'博士',pos:['中国农业科学院农业环境与可持续发展研究所 副研究员'],int:'长期致力于气候变化适应与农业绿色低碳发展研究，开展气候变化对作物产量价格影响风险及适应技术研发，构建主粮作物、茶叶、糖等农产品全生命周期温室气体排放核算体系，深入探索农产品碳中和与气候变化适应协同发展路径',src:require('../../assets/item/likuo.png')},
        {name:'赵明月',deg:'博士',pos:['中国农业科学院农业环境与可持续发展研究所 副研究员'],int:'从事气候变化适应与农业生态系统可持续发展研究，针对农业生态系统开展韧性评估、健康评价及应对气候变化适应研究，构建大豆等农产品全生命周期温室气体排放核算体系，探究农业与生态系统耦合协同发展路径。',src:require('../../assets/item/zhaomingyue.png')},

      ],
      other_items:[
        {name:'马芬',src:require('../../assets/item/mafen.jpg')},
        {name:'张靖瑜',src:require('../../assets/item/zhangjingyu.jpg')},
        {name:'刘家良',src:require('../../assets/item/liujialiang.png')},
        {name:'赵柏涵',src:require('../../assets/item/zhaobohan.jpg')},
        {name:'韩欣怡',src:require('../../assets/item/hanxinyi.jpg')},
        {name:'李文迪',src:require('../../assets/item/liwendi.jpg')},
        
      ],
      active_item:{name:'李迎春',deg:'博士',pos:['农产品碳足迹因子基准数据库 项目首席','中国农业科学院农业环境与可持续发展研究所 副研究员'],int:'主要从事低碳农业发展与农产品碳标签研究。采用全生命周期评价方法，定量核算我国典型农食产品碳足迹，探索农食产品碳标签计量方法与认证标准，构建农食产品碳标识与认证技术规范；解析不同农食产品碳排放构成，研发减排固碳技术，提出双碳目标下农食产品低碳发展路径。为地方政府、农业企业的低碳农食产品开发提供定制化解决方案。',src:require('../../assets/item/liyingchun.png')},
    }
  }
}
</script>


<style>
.item_continer{
  width: 100%;
  display: flex;
  flex-direction: column;
  /* justify-content: center;
  align-items: center; */
  background-color: #f0f0f4;
  padding: 30px 0;
  
}
.inner-div {
  display: flex;
  width: 46%; /* 大致占一半宽度，考虑到间距等因素，不是精确50% */
  margin-left: 2%; /* 给每个内层div添加一定间距 */
  margin-right: 2%;
  margin-top:4vh;
  box-sizing: border-box; /* 确保元素的尺寸计算包含边框和内边距 */
  padding: 20px 25px;
  height: 35vh;
  align-items: center;
  
  background-color: #fff;
  border-radius: 20px;
  position: relative;
  box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.5); /* 主阴影 */
  transform: rotateY(10deg);
  transition: all 0.3s ease;
  cursor: pointer;
}
.other_inner_div{
  display: flex;
  width: 15%;
  margin-left: 0.8%;
  margin-right: 0.8%;
  margin-top: 4vh;
  margin-bottom: 4vh;
  box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 15px;
  height: 30vh;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  flex-direction: column;
}

.inner-div:hover {
  transform: scale(1.1); /* 使用transform属性的scale函数将div放大到原始尺寸的1.2倍 */
  box-shadow: 10px 10px 20px 0px rgba(0, 0, 0, 0.5); /* 主阴影 */

}
.onter-div{
  width: 90%;
  display: flex;
  flex-wrap: wrap;
}
.other_other_div{
  width: 90%;
  display: flex;
  flex-wrap: wrap;
  
}
.item-avater{
  height: 95%;
  width: 30%;
   overflow: hidden
  
}
.other-item-avater{
  margin-top: 5%;
  height: 90%;
  width: 90%;
  overflow: hidden;
}
.other-item-avater img{
  height: 100%;
}
.item-avater img{
  height: 100%;
}
.item-left{
  margin-left: 20px;
  height: 100%;
  
  display: flex;
  flex-direction: column;
  flex:1;
  text-align: left;
}
.item-items{
  display:flex;
  margin-top: 5px;
}
.item-items img{
  width: 2.5vh;
  height: 2.4vh;
}
.text1{
 
  font-size: 2.2vh;
  letter-spacing: 0.1em;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
}
.text2{
  justify-content: center;
  display:flex;
  flex:1;
  flex-direction: column;
  font-size: 2.2vh;
  line-height: 1.5;
}
.item_continer .el-dialog{
  border-radius: 30px;
  width: 70vw;
}
.item_continer .el-dialog__header{
  padding: 40px 20px 0px;
}
.item_continer .el-dialog__title{
  font-size: 30px;
  color: #1d466b;
  font-weight: 600;
   letter-spacing: 0.2em;
}
.item_continer .el-dialog__body{
  padding: 30px 60px;
}
.di-item-items{
  display:flex;
  margin-top: 15px;
}
.di-text1{
   font-size: 2.4vh;
  letter-spacing: 0.2em;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
}
.di-text1 img{
  width: 2.7vh;
  height: 2.7vh;
}
.di-text2{
  justify-content: center;
  display:flex;
  flex:1;
  flex-direction: column;
  font-size: 2.4vh;
  line-height: 1.5;
}
.members{
  display: flex;justify-content: center;align-items: center;width:100%;
  background-color: #f0f0f4;
}
.item_title{
  margin-top: 4vh;
  font-size: 3vh;
  font-weight: 700;
}
</style>